/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {RootScopeService} from "../../services/rootscope.service";
import {RedirectionService} from "../../services/redirection.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SessionService} from "../../services/session.service";

@Component({
    selector: 'app-wl-footer',
    templateUrl: './wl-footer.component.html'
})
export class WlFooterComponent implements OnInit {

    constructor(public rootScope: RootScopeService, private redirectionService: RedirectionService, private sessionService: SessionService, private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit(): void {
    }

    goToContact() {
        this.redirectionService.internalContact(this.route, this.sessionService.id);
    };

    goToHelp() {
        this.redirectionService.internalHelp(this.route, this.sessionService.id);
    };

    goToLegalNotices() {
        this.redirectionService.internalLegal(this.route, this.sessionService.id);
    };

    replaceArgsInUrl(url) {
        let publicSessionId;
        let params = this.router.url.split('/')
        if (params.includes('pId')) {
            publicSessionId = params[params.indexOf('pId') + 1]
        }
        if (publicSessionId && typeof url !== 'undefined' && url !== null) {
            console.info('on change', url, publicSessionId);
            return url.replace(/%PUBLIC_SESSION_ID%/g, publicSessionId);
        }
        return url;
    };

}
